import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[540px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20cream%20colored%20comforter%20draped%20over%20a%20pristine%20white%20bed%20in%20a%20bright%20airy%20bedroom%2C%20soft%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20elegant%20and%20serene%20atmosphere%2C%20minimalist%20decor%20with%20warm%20wood%20accents%2C%20professional%20interior%20photography%2C%20clean%20fresh%20hotel%20aesthetic&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="专业被芯干洗护理服务"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 container-main text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight font-heading drop-shadow-lg">
          专业被芯干洗护理
          <br />
          <span className="text-primary-300">让每一床被子历久弥新</span>
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          10年专业被芯护理经验 · 意大利进口干洗设备 · 服务50万+家庭
          <br className="hidden md:block" />
          蚕丝被、羽绒被、美女被、羊毛毯 —— 为您的每一件寝具提供专属洗护方案
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/meinvbei"
            className="px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full text-sm hover:bg-primary-600 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
          >
            <i className="ri-vip-crown-line mr-2"></i>了解美女被干洗
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 font-medium rounded-full text-sm hover:bg-white/25 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>关于被护专家
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-6 text-white/60 text-xs">
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i>环保溶剂</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i>百万保额</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i>独立清洗</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i>免费取送</span>
        </div>
      </div>
    </section>
  );
}